var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coursework-viewer__slide"},[_c('pre',{staticClass:"coursework-viewer__text-container",class:_vm.codeClass},[_vm._v("    "),_c('code',{ref:"codeEl"}),_vm._v("\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }